import styled from 'styled-components';

export const Heading = styled.h2`
  margin: 0;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
`;

export const StyledLabel = styled.div`
  padding-top: 12px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  margin-bottom: 30px;
`;
